import React, { useState } from 'react';
import { UserPlus, Mail, Loader2 } from 'lucide-react';
import { useActions } from '../../context/AppContext';
import Modal from '../ui/Modal';
import { COMMON_INPUT_CLASS } from '../../utils/constants';
import { normalizeEmail } from '../../utils/emailUtils';
import { describeIdentityError } from '../../services/identityUniqueness';
import EmailSuggestion from '../ui/EmailSuggestion';

const OgrenciEkleModal = ({ isOpen, onClose, loggedInUser, showToast }) => {
  const { createStudentByInstructor } = useActions();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailInput, setEmailInput] = useState('');

  return (
    <Modal title="Öğrenciyi Sisteme Ekle" isOpen={isOpen} onClose={onClose}>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          if (isSubmitting) return;

          const name = String(e.target.name.value || '').trim().replace(/\s+/g, ' ');
          if (!name) {
            showToast('Öğrenci adını girin.', 'error');
            return;
          }
          const email = normalizeEmail(String(e.target.email.value || '').trim());
          if (!email || !email.includes('@')) {
            showToast('Geçerli bir e-posta adresi girin.', 'error');
            return;
          }
          const age = Number(e.target.age.value);
          if (!Number.isInteger(age) || age < 1 || age > 120) {
            showToast('Yaş 1 ile 120 arasında olmalı.', 'error');
            return;
          }

          setIsSubmitting(true);
          try {
            await createStudentByInstructor(loggedInUser, {
              name,
              email,
              age: String(age),
              parent: String(e.target.parent.value || '').trim() || '-',
            });
            showToast('Öğrenci başarıyla oluşturuldu.');
            setEmailInput('');
            onClose();
          } catch (err) {
            showToast(describeIdentityError(err) || 'Kayıt hatası!', 'error');
          } finally {
            setIsSubmitting(false);
          }
        }}
        className="space-y-4"
      >
        <div className="space-y-2 mb-2">
          <div className="bg-amber-50 dark:bg-amber-900/30 p-4 rounded-xl border border-amber-100 dark:border-amber-800 text-xs text-amber-700 dark:text-amber-400 font-medium leading-relaxed">
            <strong>Giriş:</strong> Öğrenci, e-posta adresine gelen kodla şifresiz giriş yapar.
          </div>
          <div className="bg-blue-50 dark:bg-blue-950/40 p-3 rounded-xl border border-blue-100 dark:border-blue-900/60 text-xs text-blue-700 dark:text-blue-400 leading-relaxed">
            <strong>Gizlilik:</strong> Girdiğiniz ad, iletişim ve yaş bilgileri yalnızca eğitim sürecini yürütmek amacıyla işlenecektir.
          </div>
        </div>
        <div>
          <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">Öğrenci Adı Soyadı</label>
          <input name="name" required maxLength={100} autoComplete="off" className={COMMON_INPUT_CLASS} />
        </div>
        <div>
          <label className="text-xs font-bold text-blue-600 dark:text-blue-400 uppercase flex items-center gap-2 mb-1">
            <Mail size={14} /> E-posta
          </label>
          <input
            name="email"
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="ornek@mail.com"
            required
            value={emailInput}
            onChange={(e) => setEmailInput(e.target.value)}
            className={COMMON_INPUT_CLASS}
          />
          <EmailSuggestion email={emailInput} onApply={setEmailInput} className="mt-2" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
          <div>
            <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">Öğrenci Yaşı</label>
            <input name="age" type="number" inputMode="numeric" min={1} max={120} step={1} required className={COMMON_INPUT_CLASS} />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">Veli Adı (Opsiyonel)</label>
            <input name="parent" placeholder="Boş bırakılabilir" maxLength={100} className={COMMON_INPUT_CLASS} />
          </div>
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-slate-900 dark:bg-blue-600 text-white py-4 rounded-xl font-bold mt-4 hover:bg-slate-800 dark:hover:bg-blue-700 transition-colors flex justify-center items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <>
              <Loader2 size={18} className="animate-spin" />
              Ekleniyor...
            </>
          ) : (
            <>
              <UserPlus size={18} /> Öğrenciyi Ekle
            </>
          )}
        </button>
      </form>
    </Modal>
  );
};

export default OgrenciEkleModal;
